const STORAGE_KEY = 'ordinals_wallet::secure_tickets'

export interface StoredSecureTicket {
	graphDigest: string
	t2Hex: string
	buyerAddress: string
	feeRateSatVb: number
	storedAt: number
}

function readAll(): Record<string, StoredSecureTicket> {
	if (typeof window === 'undefined') {
		return {}
	}
	try {
		const raw = window.localStorage.getItem(STORAGE_KEY)
		if (!raw) return {}
		const parsed = JSON.parse(raw) as Record<string, StoredSecureTicket>
		return parsed && typeof parsed === 'object' ? parsed : {}
	} catch {
		return {}
	}
}

export function storeSecureTicket(ticket: StoredSecureTicket): void {
	if (typeof window === 'undefined') {
		return
	}
	const all = readAll()
	all[ticket.graphDigest] = ticket
	window.localStorage.setItem(STORAGE_KEY, JSON.stringify(all))
}

export function readSecureTicket(graphDigest: string): StoredSecureTicket | undefined {
	return readAll()[graphDigest]
}

const LISTING_STORAGE_KEY = 'ordinals_wallet::secure_listed_outpoints'

function readListed(): Record<string, true> {
	if (typeof window === 'undefined') {
		return {}
	}
	try {
		const raw = window.sessionStorage.getItem(LISTING_STORAGE_KEY)
		if (!raw) return {}
		const parsed = JSON.parse(raw) as Record<string, true>
		return parsed && typeof parsed === 'object' ? parsed : {}
	} catch {
		return {}
	}
}

export function rememberSecureListing(outpoint: string): void {
	if (typeof window === 'undefined' || !outpoint) {
		return
	}
	const all = readListed()
	all[outpoint.toLowerCase()] = true
	window.sessionStorage.setItem(LISTING_STORAGE_KEY, JSON.stringify(all))
}

export function hasRememberedSecureListing(outpoint: string): boolean {
	return Boolean(readListed()[outpoint.toLowerCase()])
}
